import moment from 'moment';

export default function etaParse(company, etas) {
  if(!etas){
    return [];
  }

  if (/(KMB|LWB)/g.exec(company)) {
    return etas
      .sort((a, b) => a.eta_seq < b.eta_seq ? -1 : 1)
      .map(x => {
        const time = moment(x.eta, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('HH:mm');

        return {
          ...x,
          time,
        };
      });

  } else if (/(CTB|NWFB)/g.exec(company)) {
    return etas
      .sort((a, b) => a.eta_seq < b.eta_seq ? -1 : 1)
      .map(x => {
        // format eta
        const time = moment(x.eta, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('HH:mm');

        return {
          ...x,
          time,
        };
      });

  } else if (/NLB/g.exec(company)) {
    return etas.map(x => {
      const time = moment(x.estimatedArrivalTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');

      return {
        ...x,
        time,
      };
    });
  }

  // return empty array when there is no match
  return [];
}
